/**
 * Canvas Legacy Types
 *
 * Essential types preserved from the deprecated CanvasArchitecture system.
 * TerraMatrix now uses AI-chat-only interaction with flex-based layouts.
 * These types are retained for backward compatibility with existing components.
 *
 * @deprecated December 2025 - Spatial indexing and absolute positioning removed
 * @see /.claude/context/canvas-architecture.md for current architecture
 */

// =============================================================================
// CORE GEOMETRY TYPES
// =============================================================================

export interface Rectangle {
  x: number;
  y: number;
  width: number;
  height: number;
}

// =============================================================================
// COMPONENT TYPES
// =============================================================================

/**
 * Component bounds for spatial tracking (stub type for backward compatibility)
 * NOTE: Spatial indexing has been removed. This type is kept for backward compatibility.
 */
export interface ComponentBounds {
  id: string;
  x: number;
  y: number;
  z: number;
  width: number;
  height: number;
  type?: string;
  lastUpdated?: number;
  nestingDepth?: number;
}

// =============================================================================
// PERFORMANCE TYPES
// =============================================================================

export interface PerformanceMetrics {
  renderTime: number;
  updateFrequency: number;
  memoryUsage: number;
  frameDrops: number;
  optimizationsApplied: string[];
}

export interface PerformanceConfig {
  maxRenderTime: number;
  targetFrameRate: number;
  memoryThreshold: number;
  enableOptimizations: boolean;
  cullingEnabled: boolean;
}

// =============================================================================
// PERFORMANCE CONSTANTS
// =============================================================================

/**
 * Performance optimization constants
 * Retained for components that reference these thresholds
 */
export const PERFORMANCE_CONFIG = {
  MAX_COMPONENTS_NO_VIRTUALIZATION: 100,
  SPATIAL_INDEX_THRESHOLD: 50,
  VIEWPORT_CULL_BUFFER: 200,
  QUADTREE_MAX_COMPONENTS: 10,
  QUADTREE_MAX_LEVELS: 8,
  BATCH_UPDATE_INTERVAL: 16,
  THROTTLE_INTERVAL: 16,
  DEBOUNCE_INTERVAL: 100,
} as const;
